export default __webpack_public_path__ + "static/media/3.240d3034.webp";